export const educationalQualificationsByCategory = {
  'Doctor (Human Medical)': {
    'Modern Medicine (Allopathy)': [
      'MBBS',
      'MD',
      'MS',
      'DNB',
      'Diploma (DGO, DCH, DA, etc.)',
      'DM',
      'MCh',
      'PhD (Medical Sciences)',
    ],
    'AYUSH': [
      'BAMS',
      'BHMS',
      'BUMS',
      'BSMS',
      'BNYS',
      'MD/MS (AYUSH)',
    ],
    'Dentistry': [
      'BDS',
      'MDS',
      'PhD (Dental Sciences)',
    ],
    'Alternative / Complementary Medicine': [
      'DO (Doctor of Osteopathic Medicine)',
      'DC (Doctor of Chiropractic)',
      'ND (Doctor of Naturopathy)',
      'Acupuncture Certifications',
    ],
  },
  'Veterinary': {
    'Core': [
      'BVSc & AH',
      'MVSc',
      'Diploma in Veterinary Practices',
      'PhD (Veterinary Science)',
      'Certificate Courses (Animal Care, Livestock Management)',
    ],
  },
  'Nutritionist / Dietitian': {
    'Core Degrees': [
      'BSc Nutrition',
      'BSc Dietetics',
      'BSc Food Science',
      'MSc Nutrition',
      'MSc Dietetics',
      'MSc Clinical Nutrition',
    ],
    'Professional Certifications': [
      'RD (Registered Dietitian)',
      'CDN (Certified Dietitian/Nutritionist)',
      'CNS (Certified Nutrition Specialist)',
      'CDE (Certified Diabetes Educator)',
    ],
    'Diplomas': [
      'PG Diploma in Dietetics',
      'PG Diploma in Clinical Nutrition',
      'Diploma in Food & Nutrition',
    ],
  },
  'Physiotherapist': {
    'Core': [
      'BPT',
      'MPT',
      'DPT',
      'PhD (Physiotherapy)',
      'Diploma in Physiotherapy',
    ],
  },
  'Other': {
    'Nursing': [
      'ANM',
      'GNM',
      'BSc Nursing',
      'Post Basic BSc Nursing',
      'MSc Nursing',
      'Nurse Practitioner (NP)',
    ],
    'Pharmacy': [
      'D.Pharm',
      'B.Pharm',
      'PharmD',
      'M.Pharm',
      'PhD (Pharmacy)',
    ],
    'Mental Health': [
      'BA/BSc Psychology',
      'MA/MSc Psychology',
      'MPhil Clinical Psychology',
      'PsyD',
      'PhD Psychology',
    ],
    'Lab & Diagnostics': [
      'DMLT',
      'BMLT',
      'MMLT',
      'PhD Lab Sciences',
    ],
    'Radiology & Imaging': [
      'Diploma in Radiology',
      'BSc Radiology',
      'MSc Radiology',
      'DMRE',
    ],
    'Occupational Therapy': [
      'BOT',
      'MOT',
    ],
    'Speech & Hearing': [
      'BASLP',
      'MASLP',
    ],
    'Public Health / Administration': [
      'BPH',
      'MPH',
      'MHA',
    ],
    'Emergency & Paramedical': [
      'EMT',
      'Diploma in Emergency Care',
      'Paramedical Certifications',
    ],
    'Fitness / Wellness': [
      'Certified Personal Trainer',
      'Yoga Certification (YTTC)',
      'Sports Nutrition Certification',
    ],
  },
};

export const specializationsByCategory = {
  'Doctor (Human Medical)': {
    'General & Core': [
      'General Medicine',
      'General Physician',
      'Family Medicine',
      'Emergency Medicine',
    ],
    'Internal Medicine Super-Specialties': [
      'Cardiology',
      'Neurology',
      'Gastroenterology',
      'Nephrology',
      'Endocrinology',
      'Pulmonology (Chest Medicine)',
      'Rheumatology',
      'Infectious Diseases',
      'Hematology',
      'Oncology (Medical)',
    ],
    'Surgical Specialties': [
      'General Surgery',
      'Orthopedic Surgery',
      'Neurosurgery',
      'Cardiothoracic Surgery',
      'Plastic Surgery',
      'Pediatric Surgery',
      'Urology',
      'Vascular Surgery',
      'Gastrointestinal Surgery',
    ],
    'Women & Child': [
      'Obstetrics & Gynecology',
      'Pediatrics',
      'Neonatology',
      'Pediatric Cardiology',
      'Pediatric Neurology',
    ],
    'Diagnostic & Support': [
      'Radiology',
      'Pathology',
      'Microbiology',
      'Biochemistry',
      'Forensic Medicine',
    ],
    'Other Clinical Specialties': [
      'Dermatology',
      'Psychiatry',
      'Ophthalmology',
      'ENT (Otorhinolaryngology)',
      'Anesthesiology',
      'Pain Medicine',
      'Palliative Care',
      'Rehabilitation Medicine',
    ],
    'Dental Specialties': [
      'Dentist',
      'Orthodontics',
      'Prosthodontics',
      'Periodontics',
      'Oral Surgery',
      'Endodontics',
      'Pedodontics',
    ],
    'AYUSH Specialties': [
      'Kayachikitsa (Ayurveda Medicine)',
      'Panchakarma',
      'Shalya Tantra (Surgery)',
      'Shalakya Tantra (ENT/Eye)',
      'Homeopathy (General Practice)',
      'Unani Medicine',
      'Siddha Medicine',
      'Yoga & Naturopathy',
    ],
  },
  'Veterinary': {
    'Core': [
      'Veterinary Medicine',
      'Veterinary Surgery',
    ],
    'Animal Type Specializations': [
      'Small Animal Practice (Pets)',
      'Large Animal Practice (Cattle, Livestock)',
      'Exotic Animals',
    ],
    'Advanced Fields': [
      'Veterinary Gynecology & Obstetrics',
      'Veterinary Pathology',
      'Veterinary Microbiology',
      'Veterinary Pharmacology',
      'Veterinary Public Health',
    ],
    'Industry & Research': [
      'Animal Nutrition',
      'Livestock Production & Management',
      'Poultry Science',
      'Dairy Science',
      'Wildlife Veterinary Medicine',
    ],
  },
  'Nutritionist / Dietitian': {
    'Clinical': [
      'Clinical Nutrition',
      'Therapeutic Dietetics',
      'Renal Nutrition',
      'Cardiac Nutrition',
      'Diabetic Nutrition',
      'Oncology Nutrition',
    ],
    'Lifestyle & Wellness': [
      'Weight Management',
      'Sports Nutrition',
      'Fitness Nutrition',
      'Pediatric Nutrition',
      'Geriatric Nutrition',
    ],
    'Specialized Fields': [
      'Public Health Nutrition',
      'Maternal Nutrition',
      'Gut Health / Functional Nutrition',
      'Eating Disorders',
    ],
    'Food Science Side': [
      'Food Safety & Quality',
      'Food Technology',
      'Nutraceuticals',
    ],
  },
  'Physiotherapist': {
    'Core': [
      'Orthopedic Physiotherapy',
      'Neurological Physiotherapy',
      'Cardiopulmonary Physiotherapy',
    ],
    'Advanced': [
      'Sports Physiotherapy',
      'Pediatric Physiotherapy',
      'Geriatric Physiotherapy',
      'Women\'s Health Physiotherapy',
    ],
    'Sub-specialties': [
      'Musculoskeletal Rehab',
      'Neuro Rehab',
      'Post-Surgical Rehab',
      'Pain Management',
      'Ergonomics',
    ],
  },
  'Other': {
    'Mental Health': [
      'Clinical Psychology',
      'Counseling Psychology',
      'Marriage Counselor',
      'Psychiatry',
      'Neuropsychology',
    ],
    'Nursing Specialties': [
      'Critical Care Nursing',
      'Pediatric Nursing',
      'Oncology Nursing',
      'Psychiatric Nursing',
      'Community Health Nursing',
    ],
    'Pharmacy': [
      'Clinical Pharmacy',
      'Hospital Pharmacy',
      'Industrial Pharmacy',
      'Pharmacology',
    ],
    'Diagnostics': [
      'Medical Lab Technology',
      'Radiology & Imaging',
      'Sonography',
    ],
    'Rehabilitation & Therapy': [
      'Occupational Therapy',
      'Speech Therapy',
      'Audiology',
    ],
    'Public Health': [
      'Epidemiology',
      'Health Administration',
      'Community Medicine',
    ],
    'Emergency Services': [
      'Emergency Medical Services (EMS)',
      'Trauma Care',
    ],
    'Wellness / Alternative': [
      'Yoga Therapy',
      'Acupuncture',
      'Chiropractic',
      'Osteopathy',
    ],
  },
};

export const medicalCouncils = [
  'National Medical Commission (NMC)',
  'Andhra Pradesh Medical Council',
  'Arunachal Pradesh Medical Council',
  'Assam Medical Council',
  'Bihar Medical Council',
  'Chhattisgarh Medical Council',
  'Delhi Medical Council',
  'Goa Medical Council',
  'Gujarat Medical Council',
  'Haryana Medical Council',
  'Himachal Pradesh Medical Council',
  'Jammu & Kashmir Medical Council',
  'Jharkhand Medical Council',
  'Karnataka Medical Council',
  'Kerala Medical Council (Travancore Cochin Medical Council)',
  'Madhya Pradesh Medical Council',
  'Maharashtra Medical Council',
  'Maharashtra State Dental Council',
  'Manipur Medical Council',
  'Meghalaya Medical Council',
  'Mizoram Medical Council',
  'Nagaland Medical Council',
  'Odisha Medical Council',
  'Punjab Medical Council',
  'Rajasthan Medical Council',
  'Sikkim Medical Council',
  'Tamil Nadu Medical Council',
  'Telangana State Medical Council',
  'Tripura State Medical Council',
  'Uttar Pradesh Medical Council',
  'Uttarakhand Medical Council',
  'West Bengal Medical Council',
  'Other',
];

export const languagesSpoken = [
  'Assamese',
  'Bengali',
  'Bodo',
  'Dogri',
  'English',
  'Gujarati',
  'Hindi',
  'Kannada',
  'Kashmiri',
  'Konkani',
  'Maithili',
  'Malayalam',
  'Manipuri (Meitei)',
  'Marathi',
  'Marwadi',
  'Nepali',
  'Odia',
  'Punjabi',
  'Sanskrit',
  'Santali',
  'Sindhi',
  'Tamil',
  'Telugu',
  'Urdu',
  'Other',
];

// Helper functions analogous to Flutter's getters
export const getEducationalQualifications = (): string[] => {
  const result = new Set<string>();
  for (const group of Object.values(educationalQualificationsByCategory)) {
    for (const values of Object.values(group)) {
      (values as string[]).forEach((v: string) => result.add(v));
    }
  }
  result.add('Other');
  return Array.from(result);
};

export const getSpecializations = (): string[] => {
  const result = new Set<string>();
  for (const group of Object.values(specializationsByCategory)) {
    for (const values of Object.values(group)) {
      (values as string[]).forEach((v: string) => result.add(v));
    }
  }
  result.add('Other');
  return Array.from(result);
};
